import { useState } from 'react';

export type ShareButtonProps = {
  eventUuid?: string | null;
  scenarioUuid?: string | null;
  roomUuid?: string | null;
};

export function ShareButton(props: ShareButtonProps) {
  const [copied, setCopied] = useState<boolean>(false);

  const handleShareClick = () => {
    // get href without any query params
    const url = window.location.href.split('?')[0].trim();
    if (props.eventUuid) {
      // get base url from url, then add /events/:eventUuid
      // https://localhost:3000/....
      const baseUrl = url.split('/').slice(0, 3).join('/');
      navigator.clipboard.writeText(baseUrl + '/events/' + props.eventUuid);
    } else if (props.scenarioUuid) {
      const baseUrl = url.split('/').slice(0, 3).join('/');
      navigator.clipboard.writeText(baseUrl + '/scenarios/' + props.scenarioUuid);
    } else if (props.roomUuid) {
      const baseUrl = url.split('/').slice(0, 3).join('/');
      navigator.clipboard.writeText(baseUrl + '/rooms/' + props.roomUuid);
    } else {
      navigator.clipboard.writeText(url);
    }

    setCopied(true);

    // Reset the "copied" message after 2 seconds
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="relative">
      <button
        className={`bg-white text-black py-2 px-4 rounded hover:bg-gray-200 transition-colors duration-300 ${
          copied ? 'opacity-50' : ''
        }`}
        onClick={handleShareClick}
        disabled={copied}
      >
        Share
      </button>
      {/* Copied message */}
      {copied && (
        <div className="absolute top-full mt-2 left-0 bg-black text-center text-xs text-gray-300 p-2 rounded">
          <span className="text-sm text-white">Copied to clipboard!</span>
        </div>
      )}
    </div>
  );
}
